import { pages } from "../common/pages";
import { defaultHiddenColumns } from "./hiddenColumns";

const PAGE_SETTINGS_PREFIX = "taborminerals.";

const getDefaultPageSettings = (page) => {
  const defaults = {};

  if (page in defaultHiddenColumns) {
    defaults.hiddenColumns = defaultHiddenColumns[page];
  }

  return defaults;
};

const getStoredPageSettings = (page) => {
  if (!page) return getDefaultPageSettings(page);

  const pageSettings = localStorage.getItem(`${PAGE_SETTINGS_PREFIX}${page}`);

  if (!pageSettings) return getDefaultPageSettings(page);

  return JSON.parse(pageSettings);
};

const updateStoredPageSettings = (page, newSettings) => {
  if (!page) return;

  const pageSettings = getStoredPageSettings(page);

  localStorage.setItem(
    `${PAGE_SETTINGS_PREFIX}${page}`,
    JSON.stringify({ ...pageSettings, ...newSettings })
  );
};

const isEmptySettings = (settings) => {
  if (!settings || typeof settings !== "object") {
    return true;
  }

  return Object.values(settings).every((value) => {
    // array is empty if length is 0
    if (Array.isArray(value)) {
      return value.length === 0;
    }

    // object is empty if it has no keys
    if (value && typeof value === "object") {
      return Object.keys(value).length === 0;
    }

    return value === null || value === "" || value === undefined;
  });
};

const resetDefaultSettings = () => {
  // Loop through all pages and reset to defaults
  Object.values(pages).forEach((page) => {
    const defaultSettings = getDefaultPageSettings(page);

    if (isEmptySettings(defaultSettings)) {
      localStorage.removeItem(`${PAGE_SETTINGS_PREFIX}${page}`);
    } else {
      localStorage.setItem(
        `${PAGE_SETTINGS_PREFIX}${page}`,
        JSON.stringify(defaultSettings)
      );
    }
  });
};

export {
  resetDefaultSettings,
  getStoredPageSettings,
  updateStoredPageSettings,
};
